import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./swalTheme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme"; // Daha önce tanımladığınız tema dosyasını import edin
import { store } from './redux/store'
import { Provider } from 'react-redux'
import CssBaseline from '@mui/material/CssBaseline'

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
 // <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <App />
      </Provider>
    </ThemeProvider>
//  </React.StrictMode>
);

reportWebVitals();